import { useState } from 'react';
import plusRound from '~/assets/icons/plus_round.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { TextInput, TextInputAlign } from '~/components/ui/TextInput';
import { rage } from '~/rage';
import { ContactsStages } from '../../models/Contacts';
import { setActiveContactsState, useLayoutDispatch } from '../../redux';
import { AppBackButton } from '../AppBackButton';
import {
	StyledAvatar,
	StyledButtonContainer,
	StyledButtonContent,
	StyledContainer,
	StyledHead,
	StyledInputsContainer,
} from './AppContactsAddContact.styled';

const AppContactsAddContact = () => {
	const dispatch = useLayoutDispatch();
	const [nameValue, setNameValue] = useState('');
	const [phoneValue, setPhoneValue] = useState('');

	const handleCreateContact = async () => {
		const name = nameValue.trim();
		const phoneNumber = phoneValue.replace(/\D/g, '');
		if (!name || !phoneNumber) {
			return;
		}
		try {
			await rage.contacts.addContact(phoneNumber, name);
			dispatch(setActiveContactsState(ContactsStages.ALL_CONTACTS));
		} catch (e) {
			rage.notifications.showException(e);
		}
	};

	return (
		<div>
			<StyledHead>
				<AppBackButton
					onClick={() =>
						dispatch(setActiveContactsState(ContactsStages.ALL_CONTACTS))
					}
				/>
				<Text>Новый контакт</Text>
			</StyledHead>
			<StyledContainer>
				<StyledAvatar>
					<Text>{nameValue.slice(0, 1)}</Text>
				</StyledAvatar>
				<StyledInputsContainer>
					<TextInput
						value={nameValue}
						height={50}
						fontSize={16}
						textAlign={TextInputAlign.Center}
						onChange={(e) => setNameValue(e.target.value)}
						placeholder="Имя"
					/>
					<TextInput
						value={phoneValue}
						height={50}
						fontSize={16}
						textAlign={TextInputAlign.Center}
						onChange={(e) => setPhoneValue(e.target.value)}
						placeholder="Телефон"
					/>
				</StyledInputsContainer>
				<StyledButtonContainer>
					<Button
						color={ButtonColors.Select}
						height={ButtonHeight.Height50}
						onClick={handleCreateContact}
					>
						<StyledButtonContent>
							<img src={plusRound} />
							<Text>Создать контакт</Text>
						</StyledButtonContent>
					</Button>
				</StyledButtonContainer>
			</StyledContainer>
		</div>
	);
};

export { AppContactsAddContact };
